$mol_chip $mol_view
	sub /
		<= title
